import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
    from {
        opacity: 0;
    }

    to {
        opacity: 0.75;
    }
`;

export const PageLoader = styled.div`
  background-color: #fff;
  z-index: 10;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  opacity: 0.75;

  animation-name: ${fadeIn};
  animation-iteration-count: 1;
  animation-duration: 1000ms;
`;
